

import { SCATTERPLOT_CHART, BAR_CHART, HISTOGRAM_CHART, LINE_CHART, PARALLEL_COORDINATES_CHART } from "../Canvas/Constants";
import * as aggregation from "../aggregation/countAggregation";
import {
    histogramPredictionDataset,
    BrushingPointsScatterPlot,
    PropsGraph,
    brushingDataset,
    ParallelCoordinatesPrediction
} from "../../Globals/Globals";
import * as d3 from "d3";
import {
    PREDICTION_COLOR,
    REALDATA_COLOR,
    BRUSHING_COLOR,
    NO_PREDICTION_COLOR
} from "../../Globals/ColorConstants";
import { select as d3select, transition as d3transition } from "d3";
import {drawPredictionActual, drawPredictionLineActual} from '../Charts/ParallelCoordinates/PredictionParallelCoordinates'


export function barChartElementsClear(xaxis, yaxis, key) {
    const graph_rect_y = document.getElementsByClassName('BarChart_' + xaxis + "_" + yaxis + "_" + key);
    console.log('BarChart_clear','BarChart_' + xaxis + "_" + yaxis + "_" + key)
    for (let i = 0; i < graph_rect_y.length; i++) {
            const graph_rect = graph_rect_y[i]
            const graph_rect_parent = graph_rect.parentElement
            var brushingElements = graph_rect_parent.getElementsByClassName('BarChart_' + xaxis + "_" + yaxis + "_" + key + "_brushingelement")
            for (let j = 0; j < brushingElements.length; j++) {
                    var brushingElement = brushingElements[i]
                    
                    brushingElement.setAttribute('style', 'fill:' + REALDATA_COLOR + '; stroke-width:2;');
                    console.log('BarChart_clear brushingElement',brushingElement)
    
                }
            }
}



export function barChartResizeYAxis(id, domainMax) {
    var t = d3transition().duration(10);
    var svg = d3select("#" + id + "_svg_barchart");
    var linearYScaleChange = brushingDataset.getActualID(id).linearYScale;
    var oriHeight = brushingDataset.getActualID(id).height;
    linearYScaleChange.domain([0, Math.ceil(domainMax)]);
    var yAxisChange = brushingDataset.getActualID(id).yAxis;
    var categoriesMap = brushingDataset.getActualID(id).categoriesMap;
    yAxisChange.scale(linearYScaleChange);
    brushingDataset.getActualID(id).setlinearYScale(linearYScaleChange)


    console.log("barChartBrushElement", oriHeight);
    var g = svg
            .select(".axisY")
            .transition(t)
            .call(yAxisChange);


            
    Object.keys(categoriesMap).map(function (e) {
            svg
                    .selectAll(
                            ".BarChart_" +
                            brushingDataset.getActualID(id).xaxis +
                            "_" +
                            brushingDataset.getActualID(id).yaxis +
                            "_" +
                            e+"_"+id
                    )
                    .each(function () {
                            d3select(this).attr("y", linearYScaleChange(categoriesMap[e]));
                            d3select(this).attr(
                                    "height",
                                    oriHeight - linearYScaleChange(categoriesMap[e])
                            );
                    });

                    var histogramprediction = histogramPredictionDataset.getPredictionID(
                        id + "_predictRect"
                    );

                    if (
                        histogramprediction != null &&
                        histogramprediction.get(id + "_predictRect_" + e) != null &&
                        histogramprediction.get(id + "_predictRect_" + e).stopy != null
                    ) {
                        var predictionlength = histogramPredictionDataset
                        .getPredictionID(id + "_predictRect")
                        .get(id + "_predictRect_" + e).stopy;
                        svg
                        .selectAll(
                                "."+id+"_predictRect_"+e
                        )
                        .each(function () {
                                d3select(this).attr("y", linearYScaleChange(predictionlength));
                                d3select(this).attr(
                                        "height",
                                        oriHeight - linearYScaleChange(predictionlength)
                                );
                        });
                    }
       
    });
}


export function barChartElements(actualdata, axis, maxValue, id){
     
    var domainMax
    console.log('maxvalue',maxValue, actualdata.yaxis,actualdata.xaxis, maxValue,actualdata.domainMax)
    if (maxValue > actualdata.domainMax)
    {
            
            barChartResizeYAxis(id, maxValue)
            domainMax = maxValue + maxValue*0.1
    }
    else
    {
            barChartResizeYAxis(id, actualdata.domainMax)
            domainMax = actualdata.domainMax
    } 
    return domainMax   
    
}

export function LineChartResizeYAxis(id, domainMax) {
    console.log('domainMax', domainMax)
    var t = d3transition()
        .duration(10)
    var svg = d3select('#' + id + '_svg_linechart')
    var linearYScaleChange = brushingDataset.getActualID(id).linearYScale
    var oriHeight = brushingDataset.getActualID(id).height
    linearYScaleChange
        .domain([
            0,
            domainMax

        ])
        .nice()
        .range([oriHeight, 0]);

    var yAxisChange = brushingDataset.getActualID(id).yAxis
    var categoriesMap = brushingDataset.getActualID(id).categoriesMap
    yAxisChange.scale(linearYScaleChange)
    var g = svg.select('.axisY').transition(t).call(yAxisChange);

   var lineData = []
    var dateValues = Object.keys(categoriesMap)
    for (var i = 0; i < dateValues.length; i++) {
        lineData.push([new Date(dateValues[i]).getFullYear(), categoriesMap[dateValues[i]]])
    }
    
    d3.select("."+id)
    console.log('lineDatalineData',lineData, d3.select(id))

    d3.selectAll("."+id+"_line").remove()
    d3.select("."+id).append("path")
            .datum(lineData)
            .attr("class",id+"_line")
            .attr("fill", "none")
            .attr("stroke", REALDATA_COLOR)
            .attr("strokeWidth", "2")
            .attr("d", d3.line()
                .x(function(d) { return brushingDataset.getActualID(id).linearXScale(d[0]) })
                .y(function(d) { return brushingDataset.getActualID(id).linearYScale(d[1]) })
                )
    
    var predictionPoints
    if (histogramPredictionDataset.getPredictionLineChart(id + "_lineChart") != null) {
 
        predictionPoints = histogramPredictionDataset.getPredictionLineChart(id + "_lineChart")
    }

    if (predictionPoints && predictionPoints.predictedPath) {
       
        d3.selectAll("."+id+"_pre_line_path").remove()
        var lineDataPre = [...predictionPoints.predictedPath]
        d3.select("."+id).append("path")
            .datum(lineDataPre)
            .attr("class",id+"_pre_line_path")
            .attr("fill", "none")
            .attr("stroke", PREDICTION_COLOR)
            .attr("strokeWidth", "2")
            .attr("d", d3.line()
                .x(function(d) { return brushingDataset.getActualID(id).linearXScale(d[0]) })
                .y(function(d) { return brushingDataset.getActualID(id).linearYScale(d[1]) }))
    }
    
}

export function histogramBrushElements(axis, datasetKey, datasetIds, datasetValue) {

    var datasetwise = aggregation.allValues
    var thresholdArray = datasetValue.thresholds
    var thresholdArrayCount = new Map<String,Number>()
    datasetIds.forEach(dataID => {
    
            var datasetObject = datasetwise[dataID]
            var xaxisValue = Number.parseFloat(datasetObject[datasetValue.xaxis])
            var maxvalue = -1
            for(let k=0;k<thresholdArray.length;k++)
            {
                    if(xaxisValue<thresholdArray[k])
                    {
                     
                            break
                    }
                    else
                    {
                            maxvalue = k
                    }
            }
            
            if(maxvalue!=-1)
            {
                    if(thresholdArrayCount[maxvalue.toString()]==null)
                    {
                            thresholdArrayCount[maxvalue.toString()] =1 
                    }
                    else
                    {
                            thresholdArrayCount[maxvalue.toString()] = thresholdArrayCount[maxvalue.toString()] + 1
                    }
            }
    })

   

    Object.keys(thresholdArrayCount).map(function(e) {
        const graph_rect_y = document.getElementsByClassName('Histogram_' + axis + "_" + e + "_" + datasetKey);

        for (let i = 0; i < graph_rect_y.length; i++) {
            console.log('graph_rect_ygraph_rect_y', e, thresholdArrayCount[e])
            const graph_rect = graph_rect_y[i]
            var xforms = graph_rect.getAttribute('transform');
            var parts = /translate\(\s*([^\s,)]+)[ ,]([^\s,)]+)/.exec(xforms);
            
            if(parts != null)
            {
              
                const graph_rect_parent = graph_rect.parentElement
                var brushingElements = graph_rect_parent.getElementsByClassName('Histogram_' + axis + "_" + e + "_" + datasetKey + "_brushingelement")
                var id = graph_rect.parentElement.getAttribute('class')
               
                var firstX = parseFloat(parts[1]), firstY = parseFloat(parts[2]);

                var valueLength = brushingDataset.getActualID(datasetKey).linearYScale(thresholdArrayCount[e]) - firstY
    
                var transform = "translate(" +
                    firstX +
                    "," +
                    brushingDataset.getActualID(datasetKey).linearYScale(thresholdArrayCount[e]) +
                    ")"
                var height = brushingDataset.getActualID(datasetKey).height - brushingDataset.getActualID(datasetKey).linearYScale(thresholdArrayCount[e])
                var valueLength = - firstY
    
    
                if (brushingElements.length == 0) {
                    console.log('valueXAverage Color', valueLength, datasetKey)
                    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                    var svgNS = svg.namespaceURI;
                    var rect = document.createElementNS(svgNS, 'rect');
                    rect.setAttribute('transform', transform);
                    rect.setAttribute('class', 'Histogram_' + axis + "_" + e + "_" + datasetKey + "_brushingelement" + " " + HISTOGRAM_CHART + " _brushingelement");
                    rect.setAttribute('height', height.toString());
                    rect.setAttribute('style', 'fill:' + BRUSHING_COLOR + '; stroke-width:2;');
    
                    rect.setAttribute('width', graph_rect.getAttribute('width'));
    
    
                    console.log('valueXAverage Color 0x10ccf2', valueLength, datasetKey)
    
                    graph_rect_parent.appendChild(rect)
                }
                else {
                    for (let j = 0; j < brushingElements.length; j++) {
                        var brushingElement = brushingElements[i]
                        brushingElement.setAttribute('transform', transform);
                        brushingElement.setAttribute('height', height.toString());
                        brushingElement.setAttribute('style', 'fill:' + BRUSHING_COLOR + '; stroke-width:2;');
    
                        console.log('valueXAverage Color 0x10ccf2', valueLength, datasetKey)
                    }
                }
            }
            else
            {
               
                 const graph_rect_parent = graph_rect.parentElement
                 brushingElements = graph_rect_parent.getElementsByClassName('Histogram_' + axis + "_" + e + "_" + datasetKey + "_brushingelement")
                 if (brushingElements.length == 0) {
                    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                    var svgNS = svg.namespaceURI;
                    var rect = document.createElementNS(svgNS, "rect");
                    rect.setAttribute("x", graph_rect.getAttribute("x"));
                    rect.setAttribute(
                            "class",
                            'Histogram_' + axis + "_" + e + "_" + datasetKey + "_brushingelement"+" " + HISTOGRAM_CHART + " _brushingelement"
                    );
                    rect.setAttribute(
                            "y",
                            brushingDataset.getActualID(datasetKey).linearYScale(thresholdArrayCount[e]).toString()
                    );
                    rect.setAttribute("height", (brushingDataset.getActualID(datasetKey).height - brushingDataset.getActualID(datasetKey).linearYScale(thresholdArrayCount[e])).toString());
                    rect.setAttribute("width", graph_rect.getAttribute("width"));
                    rect.setAttribute(
                            "style",
                            "fill:" + BRUSHING_COLOR + "; stroke-width:2;"
                    );
                    graph_rect_parent.appendChild(rect);
                }
                else {
                    for (let j = 0; j < brushingElements.length; j++) {
                        var brushingElement = brushingElements[i]
                        brushingElement.setAttribute(
                            "y",
                            brushingDataset.getActualID(datasetKey).linearYScale(thresholdArrayCount[e]).toString()
                        );
                        brushingElement.setAttribute("height", (brushingDataset.getActualID(datasetKey).height - brushingDataset.getActualID(datasetKey).linearYScale(thresholdArrayCount[e])).toString());
                  
                        brushingElement.setAttribute('style', 'fill:' + BRUSHING_COLOR + '; stroke-width:2;');
    
                        console.log('valueXAverage Color 0x10ccf2', valueLength, datasetKey)
                    }
                }
            }
           
        }
    })

}

export function lineChartBrushElements(datasetIds, datasetKey, datasetValue){

                    var categoriesValues = aggregation.loadValues1;
                    var categoriesValueMap = new Map<string, number>();
                    var categoriesMap = new Map<string, number>();
                    var datasetwise = aggregation.allValues
                   
                    datasetIds.forEach(dataID => {

                        var datasetObject = datasetwise[dataID]
                        var xaxisValue = datasetObject[datasetValue.xaxis]
                        var yaxisValue = Number.parseFloat(datasetObject[datasetValue.yaxis])
                        
                        if (categoriesValueMap[xaxisValue] == null) {
                        
                                categoriesValueMap[xaxisValue] = yaxisValue
                                categoriesMap[xaxisValue] = 1

                            } else {
                            
                                categoriesValueMap[xaxisValue] = yaxisValue + categoriesValueMap[xaxisValue];
                                categoriesMap[xaxisValue] = 1 + categoriesMap[xaxisValue];

                        }

                    })
                  
                    if(datasetValue.yaxis == 'Count')
                    {
                        LineChartResizeYAxis(datasetKey, datasetValue.domainMax)
                    }
                    else
                    {
                        

                        var maxValue = 0, valueLength
                        Object.keys(categoriesValueMap).forEach(function(key) {
                          
                            valueLength = categoriesValueMap[key]
                            if((valueLength/categoriesMap[key])>maxValue)
                            {
                                    maxValue = valueLength/categoriesMap[key]
                            }
                            
                    
                        })
                        console.log('maxValue',maxValue)
                        if (maxValue > datasetValue.domainMax)
                        {
                                
                            LineChartResizeYAxis(datasetKey, maxValue + maxValue*0.1)
                        }
                        else
                        {
                            LineChartResizeYAxis(datasetKey, datasetValue.domainMax)
                        }

                        Object.keys(categoriesMap).map(function(e) {
                            categoriesMap[e] = categoriesValueMap[e] / categoriesMap[e]
                        })
                    }
                    var lineData = []
                    var dateValues = Object.keys(categoriesMap)
                    for (var i = 0; i < dateValues.length; i++) {
                        lineData.push([new Date(dateValues[i]).getFullYear(), categoriesMap[dateValues[i]]])
                    }
                   
                  
                   console.log('lineDatalineData',lineData, d3.select("."+datasetKey))

                    d3.selectAll("."+datasetKey+"_brushingelement").remove()
                    d3.select("."+datasetKey).append("path")
                            .datum(lineData)
                            .attr("class",datasetKey+"_brushingelement")
                            .attr("fill", "none")
                            .attr("stroke", BRUSHING_COLOR)
                            .attr("strokeWidth", "2")
                            .attr("d", d3.line()
                                .x(function(d) { return datasetValue.linearXScale(d[0]) })
                                .y(function(d) { return datasetValue.linearYScale(d[1]) })
                                )
         
                    
}

export function findMaxForBarChart(datasetIds, linearXScale, linearYScale, xaxis, yaxis, datasetValue, datasetKey){
    var CategoriesList =  new Set(aggregation.loadValues[datasetValue.xaxis])
    var datasetwise = aggregation.allValues

    var categoriesValueMap = new Map<string, number>();
    var categoriesMap = new Map<string, number>();
   
    datasetIds.forEach(dataID => {

        var datasetObject = datasetwise[dataID]
        var xaxisValue = datasetObject[datasetValue.xaxis]
        var yaxisValue = Number.parseFloat(datasetObject[datasetValue.yaxis])
        
        if (categoriesValueMap[xaxisValue] == null) {
        
                categoriesValueMap[xaxisValue] = yaxisValue
                categoriesMap[xaxisValue] = 1

            } else {
            
                categoriesValueMap[xaxisValue] = yaxisValue + categoriesValueMap[xaxisValue];
                categoriesMap[xaxisValue] = 1 + categoriesMap[xaxisValue];

        }

    })

    if(yaxis == 'Count')
    {
           
            var maxValue = 0
            var availableCategories = []
           
            var valueLength
         
            Object.keys(categoriesMap).forEach(function(key) {
                availableCategories.push(key)
                valueLength = categoriesMap[key]
                if(categoriesMap[key]>maxValue)
                {
                        maxValue = categoriesMap[key]
                }
                console.log('categorycategoryvalueLength',valueLength,categoriesMap[key])
                
                barChartElementsCount(xaxis, yaxis, key, 'y', valueLength, datasetValue, datasetKey)

            })
         

            return maxValue
        }
       else
        {
           
            
            var maxValue = 0
            var availableCategories = []
          
            var valueLength
            
            console.log('categorycategory',categoriesValueMap)
          
            Object.keys(categoriesValueMap).forEach(function(key) {
                availableCategories.push(key)
                valueLength = categoriesValueMap[key]
                if(categoriesValueMap[key]/categoriesMap[key]>maxValue)
                {
                        maxValue = categoriesValueMap[key]/categoriesMap[key]
                }
                console.log('categorycategoryvalueLength',key,valueLength,categoriesMap[key],valueLength/categoriesMap[key])
               

            })
            console.log('maxValue',maxValue)
            var domainMax = barChartElements(datasetValue, xaxis, maxValue, datasetKey)
            Object.keys(categoriesValueMap).forEach(function(key) {
                valueLength = categoriesValueMap[key]
                barChartElementsAvg(datasetValue.xaxis,datasetValue.yaxis, key, "y", valueLength/categoriesMap[key], datasetValue, datasetKey, domainMax)

            })
          

        return maxValue
    }
}


export function barChartElementsCount(xaxis, yaxis, key, ans, count, datasetValue, datasetKey) {

    const graph_rect_y = document.getElementsByClassName('BarChart_' + xaxis + "_" + yaxis + "_" + key+"_"+datasetKey);
    console.log('BarChart_' + xaxis + "_" + yaxis + "_" + key, count, datasetValue.linearYScale(count).toString())
    for (let i = 0; i < graph_rect_y.length; i++) {
        const graph_rect = graph_rect_y[i]
        const graph_rect_parent = graph_rect.parentElement
        var brushingElements = graph_rect_parent.getElementsByClassName('BarChart_' + xaxis + "_" + yaxis + "_" + key+"_"+datasetKey + "_brushingelement")
        var id = graph_rect.parentElement.getAttribute('class')
      
        if(count> datasetValue.categoriesMap[key])
        {
            console.log('grater',count,datasetValue.categoriesMap[key])
            var height =  datasetValue.height - datasetValue.linearYScale(datasetValue.categoriesMap[key])
            if (brushingElements.length == 0) {
                    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                    var svgNS = svg.namespaceURI;
                    var rect = document.createElementNS(svgNS, 'rect');
                 
                    rect.setAttribute('class', 'BarChart_' + xaxis + "_" + yaxis + "_" + key+"_"+datasetKey + "_brushingelement" + " " + BAR_CHART + " _brushingelement"+" "+datasetKey+"_brushingelement");
                    rect.setAttribute('y', datasetValue.linearYScale(datasetValue.categoriesMap[key]).toString());
                    rect.setAttribute('height', height.toString());
                  
                    rect.setAttribute('style', 'fill:' + BRUSHING_COLOR + '; stroke-width:2;');
            
                    graph_rect_parent.appendChild(rect)
                }
                else {
                    for (let j = 0; j < brushingElements.length; j++) {
                        var brushingElement = brushingElements[i]
                        brushingElement.setAttribute('style', 'fill:' + BRUSHING_COLOR + '; stroke-width:2;');
                        brushingElement.setAttribute('y', datasetValue.linearYScale(datasetValue.categoriesMap[key]).toString());
                        brushingElement.setAttribute('height', height.toString());
    
                      
                    }
                }
        }
        else
        {
            var height =  datasetValue.height - datasetValue.linearYScale(count)
            if (brushingElements.length == 0) {
                    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                    var svgNS = svg.namespaceURI;
                    var rect = document.createElementNS(svgNS, 'rect');
                    rect.setAttribute('x', graph_rect.getAttribute('x'));
                    rect.setAttribute('class', 'BarChart_' + xaxis + "_" + yaxis + "_" + key+"_"+datasetKey + "_brushingelement" + " " + BAR_CHART + " _brushingelement"+ " "+datasetKey+"_brushingelement");
                    rect.setAttribute('y', datasetValue.linearYScale(count).toString());
                    rect.setAttribute('height', height.toString());
                    rect.setAttribute('width', graph_rect.getAttribute('width'));
                    rect.setAttribute('style', 'fill:' + BRUSHING_COLOR + '; stroke-width:2;');
            
                    graph_rect_parent.appendChild(rect)
                }
                else {
                    for (let j = 0; j < brushingElements.length; j++) {
                        var brushingElement = brushingElements[i]
                        brushingElement.setAttribute('style', 'fill:' + BRUSHING_COLOR + '; stroke-width:2;');
                        brushingElement.setAttribute('y', datasetValue.linearYScale(count).toString());
                        brushingElement.setAttribute('height', height.toString());
    
                      
                    }
                }
        }
       

    }
}


export function barChartElementsAvg(
    xaxis,
    yaxis,
    key,
    ans,
    changedValue,
    datasetValue,
    datasetKey,
    domainMax
) {
   
    const graph_rect_y = document.getElementsByClassName(
            "BarChart_" + xaxis + "_" + yaxis + "_" + key+"_"+datasetKey
    );
    var categoriesMap = datasetValue.categoriesMap;
   
    d3.selectAll(
            "BarChart_" + xaxis + "_" + yaxis + "_" +  key+"_"+datasetKey + "_brushingelement"
    ).remove();
    var linearYScaleChange = datasetValue.linearYScale
    linearYScaleChange.domain([0, Math.ceil(domainMax)]);
   
    for (let i = 0; i < graph_rect_y.length; i++) {
            const graph_rect = graph_rect_y[i];
            const graph_rect_parent = graph_rect.parentElement;
            var brushingElements = graph_rect_parent.getElementsByClassName(
                    "BarChart_" + xaxis + "_" + yaxis + "_" +  key+"_"+datasetKey + "_brushingelement"
            );
            var orginalElement = graph_rect_parent.getElementsByClassName(
                    "BarChart_" + xaxis + "_" + yaxis + "_" +  key+"_"+datasetKey
            );
            var id = graph_rect.parentElement.getAttribute("class");
         
           
            var categoriesMap = datasetValue.categoriesMap
            

           console.log('linearYScaleChange(changedValue)',linearYScaleChange(changedValue), key,changedValue)
            var height = datasetValue.height - linearYScaleChange(changedValue);
                  
            if (brushingElements.length == 0) {
                    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                    var svgNS = svg.namespaceURI;
                    var rect = document.createElementNS(svgNS, "rect");
                    rect.setAttribute("x", graph_rect.getAttribute("x"));
                    rect.setAttribute(
                            "class",
                            "BarChart_" +
                            xaxis +
                            "_" +
                            yaxis +
                            "_" +
                            key+"_"+datasetKey +
                            "_brushingelement" +
                            " " +
                            BAR_CHART +
                            " _brushingelement"+ " "+datasetKey +
                            "_brushingelement"
                    );
                    rect.setAttribute(
                            "y",
                            linearYScaleChange(changedValue).toString()
                    );
                    rect.setAttribute("height", height.toString());
                    rect.setAttribute("width", graph_rect.getAttribute("width"));
                    rect.setAttribute(
                            "style",
                            "fill:" + BRUSHING_COLOR + "; stroke-width:2;"
                    );
                    console.log('fixed',categoriesMap[key].toFixed(1),changedValue.toFixed(1))
                    if(categoriesMap[key].toFixed(1)<=changedValue.toFixed(1))
                    {
                         if(orginalElement.length>0)
                         {
                                 var element = orginalElement[0]
                                 graph_rect_parent.insertBefore(rect, element);
                                 
                         }
                    }
                    else
                    {
                            graph_rect_parent.appendChild(rect);
                    }

                   
            }
            
    }
}

export function removeBrushElements(currentID){
   
    brushingDataset.getActualMap().forEach(function(datasetValue, datasetKey, map) {
                        
        if (datasetValue.type == BAR_CHART)
        {   
            barChartResizeYAxis(datasetKey, datasetValue.domainMax)
            d3.selectAll("."+datasetKey+"_brushingelement").remove()
        }
        if(datasetValue.type == LINE_CHART)
        {
            LineChartResizeYAxis(datasetKey, datasetValue.domainMax)
            d3.selectAll("."+datasetKey+"_brushingelement").remove()
        }
        if (datasetValue.type == HISTOGRAM_CHART)
        {   
         
            d3.selectAll("."+datasetKey+"_brushingelement").remove()
           
        }
        if(datasetKey!=currentID && datasetValue.type == PARALLEL_COORDINATES_CHART)
        {
            var pathElements = document.getElementsByClassName("forepath"+datasetKey)
   
            for (let i = 0; i < pathElements.length; i++) {
               
                var ID = pathElements[i].classList[1]
                if(pathElements[i].getAttribute('style')!= null)
                {
                    if(pathElements[i].getAttribute('style').includes(BRUSHING_COLOR))
                        pathElements[i].setAttribute("style","opacity: 0.5; stroke:" + REALDATA_COLOR+"; stroke-width:"+2)
                }
                    
            }
        }
        if(datasetKey!=currentID && datasetValue.type == SCATTERPLOT_CHART)
        {
                    var graph_scatterplot_circles = document.getElementsByClassName(
                        datasetKey + "_svg_scatterplot_draw_g_circle"
                );

                var predictionPointsScatterPlot = histogramPredictionDataset.getPredictionScatterPlot(datasetKey + "_canvas")

                var predictionIds = predictionPointsScatterPlot.predictionIds
            

                for (let i = 0; i < graph_scatterplot_circles.length; i++) {
                    var splitIds = graph_scatterplot_circles[i].getAttribute("id").split("_");
                    var currentdataID = splitIds[splitIds.length - 1];
                        graph_scatterplot_circles[i].setAttribute(
                                "style",
                                "opacity: 0.5; fill:" + REALDATA_COLOR 
                        );
                        graph_scatterplot_circles[i].setAttribute(
                                "class",
                                graph_scatterplot_circles[i].getAttribute("class") +
                                " " +
                                "_brushingelement"
                        );

                        if(predictionIds)
                        {
                            if(predictionIds.indexOf(currentdataID) >= 0)
                            {  
                                graph_scatterplot_circles[i].setAttribute(
                                    "style",
                                    "opacity: 0.5; fill:" + PREDICTION_COLOR +";stroke:"+'black'
                                );
                                graph_scatterplot_circles[i].getAttribute('class').replace('_brushingelement','')
                            }
                        }

                }
        }

    })
    
   


          

    const graph_rect_brush_elements = document.querySelectorAll("*[class$=\"_brushingelement\"]");
    graph_rect_brush_elements.forEach(graph_rect_brush_element => {
            var classList = graph_rect_brush_element.getAttribute('class').split(' ')
        
            if(classList.indexOf(SCATTERPLOT_CHART)>0)
            {
                    var classList = graph_rect_brush_element.getAttribute('class').split(' ').filter(function(value,index,arr){
                        if(value!='_brushingelement')
                            return true
                        else
                            return false
                    })
                    graph_rect_brush_element.setAttribute('class', classList.join(" "))

                    
            }
            else if(classList.indexOf(BAR_CHART)>0 || classList.indexOf(HISTOGRAM_CHART)>0 )
            {
                    graph_rect_brush_element.parentNode.removeChild(graph_rect_brush_element);
            }
            
        
    })

}


export function scatterPlotElements(dataIds, scatterPlotID) {

    if (dataIds.length == 0) {
            var graph_scatterplot_circles = document.getElementsByClassName(
                    scatterPlotID + "_svg_scatterplot_draw_g_circle"
            );

            var predictionPointsScatterPlot = histogramPredictionDataset.getPredictionScatterPlot(scatterPlotID + "_canvas")
    
            var predictionIds = predictionPointsScatterPlot.predictionIds
           

            for (let i = 0; i < graph_scatterplot_circles.length; i++) {
                var splitIds = graph_scatterplot_circles[i].getAttribute("id").split("_");
                var currentdataID = splitIds[splitIds.length - 1];
                    graph_scatterplot_circles[i].setAttribute(
                            "style",
                            "opacity: 0.5; fill:" + REALDATA_COLOR 
                    );
                    graph_scatterplot_circles[i].setAttribute(
                            "class",
                            graph_scatterplot_circles[i].getAttribute("class") +
                            " " +
                            "_brushingelement"
                    );

                    if(predictionIds)
                    {
                        if(predictionIds.indexOf(currentdataID) >= 0)
                        {  
                            graph_scatterplot_circles[i].setAttribute(
                                "style",
                                "opacity: 0.5; fill:" + PREDICTION_COLOR +";stroke:"+'black'
                            );
                            graph_scatterplot_circles[i].getAttribute('class').replace('_brushingelement','')
                        }
                    }

            }
    } else {
            var predictionPointsScatterPlot = histogramPredictionDataset.getPredictionScatterPlot(scatterPlotID + "_canvas")
    
            var predictionIds = predictionPointsScatterPlot.predictionIds
            console.log('predictionIds',predictionIds, dataIds)
            var graph_scatterplot_circles = document.getElementsByClassName(
                    scatterPlotID + "_svg_scatterplot_draw_g_circle"
            );
            for (let i = 0; i < graph_scatterplot_circles.length; i++) {
                    var splitIds = graph_scatterplot_circles[i].getAttribute("id").split("_");
                    var currentdataID = splitIds[splitIds.length - 1];
                   
                    if (dataIds.indexOf(currentdataID) >= 0) {
                            graph_scatterplot_circles[i].setAttribute(
                                    "style",
                                    "opacity: 0.5; fill:" + BRUSHING_COLOR 
                            );
                            graph_scatterplot_circles[i].setAttribute(
                                    "class",
                                    graph_scatterplot_circles[i].getAttribute("class") +
                                    " " +
                                    "_brushingelement"
                            );
                    }
                    else
                    {
                        if(predictionIds)
                        {
                            if(predictionIds.indexOf(currentdataID) >= 0)
                            {  
                                graph_scatterplot_circles[i].setAttribute(
                                    "style",
                                    "opacity: 0.5; fill:" + PREDICTION_COLOR +";stroke:"+'black'
                                );
                                graph_scatterplot_circles[i].getAttribute('class').replace('_brushingelement','')
                            }
                        } 
                    }
                   

            }
    }
   
  
}

export function parallelCoordinatesBrushElements(datasetIds, datasetKey, datasetValue) {
    var pathElements = document.getElementsByClassName("forepath"+datasetKey)
  
    for (let i = 0; i < pathElements.length; i++) {
       
        var ID = pathElements[i].classList[1]
        
        if(datasetIds.includes(ID))
        {
            pathElements[i].setAttribute("style","opacity: 1; stroke:" + BRUSHING_COLOR+"; stroke-width:"+2)
        }
        else
        {
            pathElements[i].setAttribute("style","opacity: 0.5; stroke:" + REALDATA_COLOR+"; stroke-width:"+2)
        }


    }

    if(histogramPredictionDataset.getPredictionParallelCoordinatesChart(datasetKey) != null)
    {
        var graph_forepaths= document.getElementsByClassName("forepath");

        for (let i = 0; i < graph_forepaths.length; i++) {
  
          graph_forepaths[i].setAttribute(
            "style",
            "opacity: 0.2; stroke: "+"grey"+"; "
            );
        }
       var predictionParallelCoordinates = histogramPredictionDataset.getPredictionParallelCoordinatesChart(datasetKey)
        console.log('predictionParallelCoordinatesseedata',predictionParallelCoordinates)
        for(var row=0;row<predictionParallelCoordinates.axesPrediction.length;row++)
        {
          var predictionParallelCoordinate:ParallelCoordinatesPrediction = predictionParallelCoordinates.axesPrediction[row]
          var dataAll = []
          for (let [key, value] of Object.entries(predictionParallelCoordinate.predictionPoints)) {
                var data = value[0]

               drawPredictionActual(key, value, datasetValue.linearScalePoint,predictionParallelCoordinate )
                var keys = key.split(":")
                dataAll.push([key,value])
               
          }
          drawPredictionLineActual(dataAll, row)

        }

       
    }
}


